module.exports = __webpack_public_path__ + "static/media/CalciteWebCoreIcons.3fee3fa6.ttf";